module.exports = __webpack_public_path__ + "img/login-bg-2.6bd0dd2f.jpg";